import { isCardDeleted } from './card-utils';
import type { SpacedRepetitionCard } from './types';

/** Placeholder `front` while a card row is still loading (Flashka clients). */
export const FLASHKA_LOADING_CARD_FRONT_PLACEHOLDER = 'Loading...';

/**
 * Cards suitable for study counts and deck chrome: not deleted, not a loading stub,
 * and without a soft-delete timestamp.
 */
export function filterVisibleStudyCards<TCard extends SpacedRepetitionCard>(
  cards: readonly TCard[],
): TCard[] {
  return cards.filter(
    (card) =>
      !isCardDeleted(card) &&
      card.front !== FLASHKA_LOADING_CARD_FRONT_PLACEHOLDER &&
      !card.deletedTimeISO,
  );
}

export const decksUtils = {
  getVisibleDeck: filterVisibleStudyCards,
};
